import React from "react";
import installations from "../data/installation-data";

const Customers = () => {
  return (
    <div className="page-container customers-page">
      <p className="main-heading">Our Customers</p>
      <p className="paragraph">
        Within a short span of time, Indelect as an organization has had the
        great privilege of working with a number of prominent organizations and
        individuals. With an enormous base of clientele, growing at a sound
        pace, Indelect aspires to build long lasting ties by providing world
        class services and solutions
      </p>
      <div className="customers-grid">
        {installations.map((item, index) => (
          <div className="customer-card" key={index}>
            <span className="customer-location">{item.location}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Customers;
